import React from "react";
import UploadDocument from "./UploadDocument";
import UploadINILA from "./UploadINILA";
import UploadDMS from "./UploadDMS";

export const DocumentTypeEnum = {
    Passport: "Passport",
    Numbers: "Numbers",
    Military: "Military",
    Driver: "Driver",
    PassportInternational: "PassportInternational",
    Pension: "Pension",
    ResidencePermit: "ResidencePermit",
    AddressOfficial: "AddressOfficial",
    AddressFact: "AddressFact",
    HealthInsurance: "HealthInsurance"
}

export const ActionType = {
    Link: "Link",
    Code: "Code"
}

export const documentTypeActions = [
    {
        ActionId: "Passport_Add",
        ReqTypeId: null,
        DocumentTypeId: DocumentTypeEnum.Passport,
        Title: "Document_Actions_Passport_Add_Title",
        DisplayName: "Document_Actions_Passport_Add_DisplayName",
        SuccessMessage: "Document_Actions_Passport_Add_SuccessMessage",
        ErrorMessage: "Document_Actions_Passport_Add_ErrorMessage",
        ConfirmationText: "Document_Actions_Passport_Add_ConfirmationText",
        CommitMessage: "Document_Actions_Passport_Add_CommitMessage",
        Action: (props) => <UploadDocument {...props}/>
    },
    {
        ActionId: "INILA_Change",
        ReqTypeId: "change",
        DocumentTypeId: DocumentTypeEnum.Numbers,
        Title: "Document_Actions_INILA_Change_Title",
        DisplayName: "Document_Actions_INILA_Change_DisplayName",
        SuccessMessage: "Document_Actions_INILA_Change_SuccessMessage",
        ErrorMessage: "",
        ConfirmationText: "Document_Actions_INILA_Change_ConfirmationText",
        CommitMessage: "Document_Actions_INILA_Change_CommitMessage",
        Action: (props) => <UploadINILA {...props}/>
    },
    {
        ActionId: "AddressOfficial_Add",
        ReqTypeId: null,
        DocumentTypeId: DocumentTypeEnum.AddressOfficial,
        Title: "Document_Actions_AddressOfficial_Add_Title",
        DisplayName: "Document_Actions_AddressOfficial_Add_DisplayName",
        SuccessMessage: "Document_Actions_AddressOfficial_Add_SuccessMessage",
        ErrorMessage: "Document_Actions_AddressOfficial_Add_ErrorMessage",
        ConfirmationText: "AddressOfficial_Add_ConfirmationText",
        CommitMessage: "Document_Actions_AddressOfficial_Add_CommitMessage",
        Action: (props) => <UploadDocument {...props}/>
    },
    {
        ActionId: "HealthInsurance_ChangeCity",
        ReqTypeId: "ChangeCity",
        DocumentTypeId: DocumentTypeEnum.HealthInsurance,
        Title: "Document_Actions_HealthInsurance_ChangeCity_Title",
        DisplayName: "Document_Actions_HealthInsurance_ChangeCity_DisplayName",
        SuccessMessage: "",
        ErrorMessage: "",
        ConfirmationText: "Document_Actions_HealthInsurance_ChangeCity_ConfirmationText",
        CommitMessage: "Document_Actions_HealthInsurance_ChangeCity_CommitMessage",
        Action: (props) => <UploadDMS {...props}/>
    },
    {
        ActionId: "AddressFact_Add",
        ReqTypeId: null,
        DocumentTypeId: DocumentTypeEnum.AddressFact,
        Title: "Document_Actions_AddressFact_Add_Title",
        DisplayName: "Document_Actions_AddressFact_Add_DisplayName",
        SuccessMessage: "Document_Actions_AddressFact_Add_SuccessMessage",
        ErrorMessage: "Document_Actions_AddressFact_Add_ErrorMessage",
        ConfirmationText: "Document_Actions_AddressFact_Add_ConfirmationText",
        CommitMessage: "Document_Actions_AddressFact_Add_CommitMessage",
        Action: (props) => <UploadDocument {...props}/>
    }
]

export function getDocumentTypeActions(documentTypeId, appParams) {
    if(documentTypeId === DocumentTypeEnum.Numbers){
        if(!appParams.showButtonsSNILS){
            return null;
        }
    }
    return documentTypeActions.filter(d => d.DocumentTypeId === documentTypeId)
}

export function getDocumentTypeAction(actionId) {
    return documentTypeActions.find(d => d.ActionId === actionId)
}